// Buckets a list of topics/sub-topics into High/Medium/Low "how often this
// appears in board papers" tiers, relative to the rest of the current list
// (top/middle/bottom third by rank) — there's no fixed absolute scale for
// "appears often" across different subjects or topic sets.
export type FrequencyTier = 'High' | 'Medium' | 'Low';

export function frequencyTiers<T>(items: T[], countOf: (item: T) => number): Map<T, FrequencyTier> {
  const sorted = [...items].sort((a, b) => countOf(b) - countOf(a));
  const n = sorted.length;
  const map = new Map<T, FrequencyTier>();
  sorted.forEach((item, i) => {
    const tier: FrequencyTier = i < n / 3 ? 'High' : i < (2 * n) / 3 ? 'Medium' : 'Low';
    map.set(item, tier);
  });
  return map;
}
